/* import __COLOCATED_TEMPLATE__ from './count.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();